// export const BASE_URL = "http://localhost:8000/api";
// export const IMAGE_PATH = "http://localhost:8000";

// export const CLIENT_ID = '272528117587-grjvdfjoqrh78jfp1212uinqa50j2b7f.apps.googleusercontent.com'

export const CLIENT_ID ='24534174823-2ealm27mqv88qhh50uo87gqrfj7comqg.apps.googleusercontent.com'
export const BASE_URL = "https://vskfortrial.xkeiwellness.com/apis/public/api";
export const IMAGE_PATH = "https://vskfortrial.xkeiwellness.com/apis/public";
